import axios from 'axios';

export function getOutreachTemplates(token, audienceType = 'launch_unpaid') {
    return axios.get(`${process.env.REACT_APP_API_URL}/admin/outreach/templates`, {
        params: { audienceType },
        headers: { Authorization: `${token}` },
    });
}

export function sendOutreachReminder(token, payload) {
    return axios.post(`${process.env.REACT_APP_API_URL}/admin/outreach/send`, payload, {
        headers: { Authorization: `${token}` },
    });
}

const MERGE_TAG_PATTERN = /\{\{\s*(\w+)\s*\}\}/g;

export function previewOutreachTemplate(template, vars) {
    const safe = vars || {};
    return String(template || '').replace(MERGE_TAG_PATTERN, (_, key) => {
        const value = safe[key];
        return value !== undefined && value !== null ? String(value) : '';
    });
}

export function resolveLaunchContinue(token) {
    return fetch(
        `${process.env.REACT_APP_API_URL}/launch/continue/resolve?token=${encodeURIComponent(token)}`
    ).then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.success) {
            throw new Error(data.error || 'Invalid or expired continue link');
        }
        return data;
    });
}
